import BaseApiService from './baseApiService';
import {
    CreateAirportCommand,
    AirlineCompanyVM,
    AirportVM,
    CityVM,
    DocumentTypeVM,
    PassengerTypeVM,
    QuotaCategoryResponse,
    SubsRouteResponse,
    UpdateAirportCommand,
    CreateCityCommand,
    UpdateCityCommand,
    CreateAirlineCommand,
    UpdateAirlineCommand,
    Holiday,
    AirlineLookupValue,
    Paginated,
    GetAirlineLookupValuesRequest
} from '../contracts';
import { RcFile } from 'antd/lib/upload';

class GuidesApiService extends BaseApiService {
    getAirports = () => {
        return this.get<AirportVM[]>('airports');
    };

    createAirport = (command: CreateAirportCommand) => {
        return this.post<void, CreateAirportCommand>('airports', command);
    };

    updateAirport = (command: UpdateAirportCommand) => {
        return this.put<void, UpdateAirportCommand>('airports', command);
    };

    getAirlines = () => {
        return this.get<AirlineCompanyVM[]>('airlines');
    };

    createAirline = (command: CreateAirlineCommand) => {
        return this.post<void, CreateAirlineCommand>('airlines', command);
    };

    updateAirline = (command: UpdateAirlineCommand) => {
        return this.put<void, UpdateAirlineCommand>('airlines', command);
    };

    getAirlineLookupValues = (request: GetAirlineLookupValuesRequest) => {
        return this.post<Paginated<AirlineLookupValue>, GetAirlineLookupValuesRequest>(
            'airlines/lookup-values',
            request
        );
    };

    getCities = () => {
        return this.get<CityVM[]>('cities');
    };

    getCitySelectOptions = async (filter: { iataCode: string; name: string }) => {
        let cities = await this.get<CityVM[]>('cities');
        if (filter.iataCode) {
            cities = cities.filter((city) => city.iataCode.toLowerCase().includes(filter.iataCode.toLowerCase()));
        }
        if (filter.name) {
            cities = cities.filter((city) => city.name.toLowerCase().includes(filter.name.toLowerCase()));
        }
        return cities.map((city) => ({ value: city.iataCode, label: city.iataCode, fields: city }));
    };

    createCity = (command: CreateCityCommand) => {
        return this.post<void, CreateCityCommand>('cities', command);
    };

    updateCity = (command: UpdateCityCommand) => {
        return this.put<void, UpdateCityCommand>('cities', command);
    };

    getDocumentTypes = () => {
        return this.get<DocumentTypeVM[]>('documentTypes');
    };

    getPassengerTypes = () => {
        return this.get<PassengerTypeVM[]>('passengerTypes');
    };

    getQuotaCategories = () => {
        return this.get<QuotaCategoryResponse[]>('quotaCategories');
    };

    getSubsRoutes = () => {
        return this.get<SubsRouteResponse[]>('subsidized-routes');
    };

    getTicketTypes = () => {
        return this.get<{ code: string; type: string }[]>('ticketTypes');
    };

    importHolidays = (file: RcFile) => {
        const form = new FormData();
        form.append('file', file);
        return this.post<void, FormData>('holidays', form);
    };

    getHolidays = () => {
        return this.get<Holiday[]>('holidays');
    };
}

export default new GuidesApiService();
